import { useEffect } from "react";
import parse from 'html-react-parser';
import store from "../../../_services/store";
import { BackButton } from "../../_ui";
import labels from '../../../_translations/biblio.json';
import styled from "styled-components";
import { COLORS } from "../../../constants";
import { observer } from "mobx-react";

const Container = styled.div`
  padding: 0px 40px 100px 40px;
  color: ${COLORS.DARK};
`;

const BibliographyPage = observer(() => {
  useEffect(() => {
    store.getBiblio()
  }, [])

  // Afficher toutes les sections de la bibliographie
  const sections = store.biblioData?.map((section, i: number) => {
    return (
      <div key={`biblio_section_${section.id || i}`} style={{ marginBottom: '40px' }}>
        {parse(section.content || '<div></div>')}
      </div>
    )
  }) || [];

  return (
    <div className="fadeIn">
      <BackButton title={labels[store.currentLanguage].labels.title} />
      <Container>
        {sections}
      </Container>
    </div>
  )
})

export default BibliographyPage;